<template>
  <div class="notifications-bar">
    <span class="notifications-icon">X</span>
    Some of your active campaigns run on a bid lower than the new minimum bid. Therefore, you need to either pause your campaigns or increase your bid. Please note that the system will automatically increase and update the bids by February 1st.
  </div>
</template>

<script>
export default {
  computed: {
    isNotAdmin () {
      return !this.$can('speakol_dashboard')
    },
    currentRouteName () {
      return this.$route.name
    },
    canViewBtn () {
      return this.$can('add_personal_fund') && this.currentRouteName !== 'fund'
    }
  }
}
</script>

<style lang="scss" scoped>
.notifications-bar {
  color: rgba(0, 0, 0, 0.65);
  background-color: #fff1f0;
  border: 1px solid #ffa39e;
  border-radius: 0.5rem;
  text-align: left;
  padding: 15px 20px;
  margin-bottom: 30px;

  .close {
    float: right;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.45);
  }

  .info-icon {
    font-size: 14px !important;
    margin-right: 3px;
    position: relative;
    top: 1px;
  }

  .route-fund-page {
    color: rgba(0, 0, 0, 0.65) !important;
    font-weight: bold !important;
    padding: 0 !important;
    text-decoration: underline !important;
  }

  .notifications-icon {
    background-color: #f5222d !important;
    color: white !important;
    border-radius: 100% !important;
    padding: 3px 9px !important;
    margin-right: 5px !important;
    font-size: 11px !important;
  }
}
</style>
